import { Component, ElementRef, Host, Input, Renderer2 } from '@angular/core';
import { BasePaneComponent } from 'sharedFeatures/base-pane';
import { LicensePackageOptions, LicensePackageType } from 'sharedFeatures/enums';
import { Subscription } from "sharedFeatures/sharedModels";
import { AuthUtils } from 'sharedFeatures/utils';
import { BillingDetailsComponent } from '../billing-details.component';
import { BillingSubscriptionBodyComponent } from './billing-subscription-body.component';

@Component(
    {
        selector: 'billing-subscription-pane',
        templateUrl: './billing-subscription-pane.component.html',
        styleUrls: ['../../base-pane/base-pane.component.less']
    })
export class BillingSubscriptionPaneComponent extends BasePaneComponent {

    subscriptionText = $localize`Subscription`;

    @Input()
    UserSubscription: Subscription = new Subscription();

    title = '';
    borderTopRadius = 0;

    width = 600;

    isDetailsActive: Boolean = false;
    private winRefs: Map<any, any> = new Map<any, any>();

    constructor( @Host() public parent: BillingDetailsComponent,
        el: ElementRef, renderer: Renderer2
    ) {

        super(el, renderer);

        this.contentComponent = BillingSubscriptionBodyComponent;

        this.isDetailsActive = parent.isDetailsActive;
    }

    ngAfterViewInit() {
        const packageType = AuthUtils.getLicensePackageType(this.UserSubscription.PriceOptionCodes);
        let licenseName = LicensePackageOptions.get(packageType)!.OptionName;

        this.init();
    }

    onBottomLinkClick(): void {

        this.isDetailsActive = (!this.isDetailsActive);
        this.parent.isDetailsActive = this.isDetailsActive;

    }

    refreshSubscriptions(callback: Function): void {

        this.parent.loadSubscriptions(callback);
    }

}